import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    DialogActions,

} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';



const useStyles = makeStyles({
    boxContent: {
        display: 'flex',
        justifyContent: 'center',
    },
});
const ConfirmationDialog = (props) => {
    const classes = useStyles();

    const onClick = (value) => {

        if (value === "cancel") {
            props.onCancelClick(false);
        }
        else if (value === "ok") {
            props.handleCnfClick();
        }
    }

    return (
        <div>
            <Dialog id="confirmationDialog"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'lg'}
                fullWidth={props.fullWidth}
            >
                {props.title ?
                    <DialogTitle id="alert-dialog-title">
                        {props.title}
                    </DialogTitle> : null
                }
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" >
                        {props.showFormattedMsg ?
                            props.messageFormat()
                            : props.message}
                    </DialogContentText>
                </DialogContent>
                {props.note ?
                    <DialogContent>
                        <Box className={classes.boxContent}>
                            <TextField
                                fullWidth
                                id="outlined-multiline"
                                label="Notes"
                                multiline
                                rows={4}
                                onChange={(event) => {
                                    props.allNoteValue(event.target.value)
                                }}
                                inputProps={{ maxLength: 1000 }}
                            />
                        </Box>
                    </DialogContent> : null}
                <DialogActions>
                    <Button onClick={() => onClick("cancel")} color="primary">
                        {props.CancelButtonText}
                    </Button>
                    <Button onClick={() => onClick("ok")} autoFocus={props.OkButtonText === 'No' ? false : true}>
                        {props.OkButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ConfirmationDialog;

ConfirmationDialog.defaultProps = {
    CancelButtonText: "Cancel",
    OkButtonText: "OK",
    title: '',
    message: '',
    showFormattedMsg: false
}